import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LeadService } from 'src/app/private/services/lead.service';
import { RegistrationService } from 'src/app/private/services/registration.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-move-to-registration',
  imports: [SharedModule],
  templateUrl: './move-to-registration.component.html',
  styleUrl: './move-to-registration.component.scss'
})
export class MoveToRegistrationComponent {

  @Output() closeDialog = new EventEmitter();
  @Input() editLeadData: any = {};
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private api : LeadService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  handleMove(){
    this.isLoading = true;

    const payload = {
      ...this.editLeadData,
      current_stage: 'registration',
      reg_data :{},
      old_lead_data: this.editLeadData,
    }

    this.api.updateLead(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.messageService.add({severity:'success', summary: 'Success', detail: 'Lead moved to registration successfully'});
        this.closeDialog.emit();
      },
      error: (error) => {
        this.messageService.add({severity:'error', summary: 'Error', detail: 'Something went wrong'});
        this.isLoading = false;
      }
    }
    );

  }
}
